export const CATEGORIEEN = {
  actie_ontbreekt: "Actie ontbreekt",
  interpretatie: "Verkeerd begrepen",
  kennis: "Kennis ontbreekt",
  techniek: "Technische fout",
} as const;
export const STATUSSEN = [
  "nieuw",
  "onderzoek",
  "klaar_voor_bouw",
  "in_bouw",
  "testen",
  "live",
  "opgelost",
  "afgewezen",
] as const;
export const PLANVELDEN = [
  "oorzaak",
  "oplossing",
  "risico",
  "test",
  "tegenvoorbeeld",
  "vraag",
] as const;
export type VerbeterStatus = (typeof STATUSSEN)[number];
export const VOLGENDE: Record<VerbeterStatus, readonly VerbeterStatus[]> = {
  nieuw: ["onderzoek", "afgewezen"],
  onderzoek: ["klaar_voor_bouw", "afgewezen"],
  klaar_voor_bouw: ["onderzoek", "in_bouw", "afgewezen"],
  in_bouw: ["onderzoek", "testen"],
  testen: ["in_bouw", "live"],
  live: ["onderzoek", "opgelost"],
  opgelost: ["onderzoek"],
  afgewezen: ["onderzoek"],
};
export type Verbeterpunt = {
  id: string;
  titel: string;
  categorie: keyof typeof CATEGORIEEN;
  status: (typeof STATUSSEN)[number];
  prioriteit: number;
  eigenaar: string;
  versie: number;
  plan: Record<string, string>;
  analyse: Record<string, string> | null;
  live_ref: string;
  controle_ref: string;
  terugkoppeling: string;
  updated_at: string;
};
export type Melding = {
  id: string;
  verbeterpunt_id: string;
  kanaal: "mail" | "voice";
  bron_id: string;
  melder: string;
  verwachting: string;
  context: Record<string, unknown>;
  klant_status: string;
  klant_notitie: string;
  versie: number;
};
export function uuid(value: unknown): value is string {
  return (
    typeof value === "string" &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      value,
    )
  );
}
export function tekst(value: unknown, max = 3000): string {
  return typeof value === "string" ? value.trim().slice(0, max) : "";
}
export function planVelden(value: unknown): Record<string, string> {
  const bron =
    value && typeof value === "object"
      ? (value as Record<string, unknown>)
      : {};
  return Object.fromEntries(PLANVELDEN.map((k) => [k, tekst(bron[k])]));
}
